import React, { useState } from 'react'
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

import SampleImage from "./../../../images/tw_persona.jpeg";
import "./ImageSelector.css";

const ImageSelector = ({ close, uploadedImage, chooseImage, imageLoader }) => {

  const [dragging, setDragging] = useState(false);

  const handleDragOver = (e) => {
    e.preventDefault();
  }

  const handleDragEnter = (e) => {
    e.preventDefault();
    setDragging(true);
  }

  const handleDragLeave = (e) => {
    e.preventDefault();
    setDragging(false);
  }

  const handleDrop = (e) => {
    e.preventDefault();
    setDragging(false);

    uploadedImage(e.dataTransfer.files[0]);
  }

  return (
    <>
      <div className='uploader__main'>
        <div
          className="uploader__main__dropper"
          onDragOver={handleDragOver}
          onDragEnter={handleDragEnter}
          onDragLeave={handleDragLeave}
          onDrop={handleDrop}
          style={{ border: dragging ? "1px dashed #043D4E" : "" }}
        >
          <div className={dragging ? "uploader__main__dropper__container" : "uploader__main__dropper__container enable"}>
            <Typography variant="body1" component="p" mb={1.25}>
              Drag and drop files here
            </Typography>
            <Typography variant="body1" component="p" mb={1.25}>
              - or -
            </Typography>
            <Button
              variant="contained"
              color="primary"
              size="medium"
              onClick={chooseImage}
            >
              Choose Files
            </Button>
          </div>
        </div>
        <div className='uploader__main__sample'>
          <div className='uploader__main__sample__image'>
            <img src={SampleImage} alt='Sample Image' />
          </div>
          <Typography variant="subtitle2" component="p" sx={{ textAlign: "center" }}>
            Please use this sample image as your reference
          </Typography>
        </div>

        <div className={imageLoader ? "uploader__main__loader visible" : "uploader__main__loader"}>
          <CircularProgress color='info' />
        </div>
      </div>
      <div className="uploader__bottom">
        <Button
          variant="outlined"
          color="primary"
          size="medium"
          onClick={close}
        >
          Close
        </Button>
      </div>
    </>
  );
}

export default ImageSelector;
